import { CreateCompanyRequest, UpdateCompanyRequest } from "../api/barcodeSystem/barcodeCompanies/create";
import { CompanyResource } from "../api/barcodeSystem/barcodeCompanies/get";

export class EditBarcodeCompanyModel {
    id: number | null;
    companyName: string;
    requiresStaging: boolean;
    assignPalletLocationAfterReceiving: boolean;
    requiresSignature: boolean;
    logOrderStatusChange: boolean;
    enableReturns: boolean;
    requiresPhoto: boolean;
    useOrderGroupText2: boolean;
    allowLoadReceiving: boolean;
    allowManualNoScanItems: boolean;
    visible: boolean = false;
    loading: boolean = true;
    saving: boolean = false;

    get isNew(): boolean {
        return this.id === null;
    }

    showForNewCompany() {
        this.loading = false;
        this.id = null;
    }

    showForExistingCompany(company: CompanyResource) {
        this.loading = false;
        
    }

    toCreateCompanyRequest(): CreateCompanyRequest {
        return { 
            companyName: this.companyName,
            requiresStaging: this.requiresStaging,
            assignPalletLocationAfterReceiving: this.assignPalletLocationAfterReceiving,
            requiresSignature: this.requiresSignature,
            logOrderStatusChange: this.logOrderStatusChange,
            enableReturns: this.enableReturns,
            requiresPhoto: this.requiresPhoto,
            useOrderGroupText2: this.useOrderGroupText2,
            allowLoadReceiving: this.allowLoadReceiving,
            allowManualNoScanItems: this.allowManualNoScanItems
        };
    }

    toUpdateCompanyRequest(): UpdateCompanyRequest {
        return {
            id: this.id,
            companyName: this.companyName,
            requiresStaging: this.requiresStaging,
            assignPalletLocationAfterReceiving: this.assignPalletLocationAfterReceiving,
            requiresSignature: this.requiresSignature,
            logOrderStatusChange: this.logOrderStatusChange,
            enableReturns: this.enableReturns,
            requiresPhoto: this.requiresPhoto,
            useOrderGroupText2: this.useOrderGroupText2,
            allowLoadReceiving: this.allowLoadReceiving,
            allowManualNoScanItems: this.allowManualNoScanItems
        };
    }
}
